export default {
  subdomain: {
    presence: true,
    length: {
      minimum: 3,
      message: "must be at least 3 characters"
    },
    format: {
      pattern: /[\w-]+/,
      message: "can only contain letters, numbers, and dashes"
    }
  },
  title: {
    presence: true,
    length: {
      minimum: 3,
      message: "must be at least 3 characters"
    }
  },
  customDomain: {
    presence: false,
    format: {
      pattern: /(^$|^(?:[\w-]+\.)*([\w-]{1,63})(?:\.(?:\w{3,}|\w{2,}))(?:$|\/))/i,
      message: "must be valid domain"
    }
  },
  bibles: {
    length: {
      minimum: 1,
      message: "must include at least 1 Bible"
    }
  },
  enabledUserAccounts: {
    presence: true
  },
  isWhiteHeader: {
    presence: true
  },
  includeAllBibles: {
    presence: true
  },
  showBibleAbbreviations: {
    presence: true
  },
  published: {
    presence: true
  },
  // function required to handle case of empty string :-/
  linkFacebook: value => {
    if (value === "") return null;
    return { url: true };
  },
  linkTwitter: value => {
    if (value === "") return null;
    return { url: true };
  },
  linkWebsite: value => {
    if (value === "") return null;
    return { url: true };
  },
  linkAppStore: value => {
    if (value === "") return null;
    return { url: true };
  },
  linkPlayStore: value => {
    if (value === "") return null;
    return { url: true };
  },
  appStoreName: {
    presence: false,
    length: {
      minimum: 3,
      maximum: 30,
      message: "must have at least 3 and less than 30"
    }
  },
  appStoreSubtitle: {
    presence: false,
    length: {
      minimum: 0,
      maximum: 30,
      message: "must have less than 30"
    }
  },
  keywords: {
    presence: false,
    length: {
      minimum: 0,
      maximum: 100,
      message: "must have less than 100"
    }
  },
  primaryLanguage: {
    presence: true
  },
  secondaryLanguage: {
    presence: false
  }
};
